import script from "./bonusView.vue?vue&type=script&setup=true&lang=ts"
export * from "./bonusView.vue?vue&type=script&setup=true&lang=ts"

import "./bonusView.vue?vue&type=style&index=0&id=4ce51c81&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ce51c81"]])

export default __exports__